import React, { lazy } from 'react';
const ShowroomTypes = () => {
  const showrooms = [{
    title: 'Luxury Auto Dealerships',
    description: 'Enhance the car buying experience with premium refreshments that keep customers comfortable during extended consultations and test drives.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/babXSRDB6KoFYSjzmKnzNJ/Auto_Dealerships2.webp'
  }, {
    title: 'Luxury Watch & Fine Jewelry Boutiques',
    description: 'Create an exclusive atmosphere where clients can enjoy premium beverages while browsing high-value items in a relaxed setting.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hG1aR5qZyLWztzPLf7h4Vc/Watch__Fine_Jewelry_Boutiques4.webp'
  }, {
    title: 'High-end Furniture & Interior Design Studios',
    description: 'Complement your design aesthetic with sophisticated beverage options that reflect your attention to detail and quality.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oAT1mvLqBC8h4V2HwAPNTF/Furniture__Interior_Design_Studios5.webp'
  }, {
    title: 'Kitchen/Bath & Premium Appliance Showrooms',
    description: 'Demonstrate your appliances in action with a beverage system that showcases innovation and enhances the customer experience.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5xTDaiWkbmWvRouTujsQkH/KitchenBath1.webp'
  }, {
    title: 'Luxury Real-Estate Brokerage Lounges',
    description: 'Elevate property viewings and client consultations with premium refreshments that make potential buyers feel at home.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xhc4MYBKepYsMTPWEgiUW3/Real-Estate_Brokerage_Lounges2.webp'
  }, {
    title: 'Hi-Fi Audio & Home Theater Boutiques',
    description: 'Complete the sensory experience with premium beverages while clients test audio equipment and envision their entertainment spaces.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/m4mw2Rhq5QjMMNKnfMWjTN/Hi-Fi_Audio__Home_Theater1.webp'
  }];
  return <section className="py-20 bg-gradient-to-b from-white to-blue-50" data-id="element-671">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-672">
        <div className="text-center mb-16" data-id="element-673">
          <span className="inline-block px-4 py-1.5 bg-blue-100 text-blue-700 rounded-full text-sm font-medium mb-4" data-id="element-674">
            IDEAL ENVIRONMENTS
          </span>
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-675">
            The Top 6 Showroom Types for SmartSoda
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-676">
            Premium beverage experiences perfectly suited for these high-end
            customer environments
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-677">
          {showrooms.map((showroom, index) => <div key={index} className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-678">
              <div className="h-48 overflow-hidden" data-id="element-679">
                <img src={showroom.image} alt={showroom.title} className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500" width="400" height="300" loading="lazy" decoding="async" data-id="element-680" />
              </div>
              <div className="p-6" data-id="element-681">
                <h3 className="text-xl font-bold text-navy-950 mb-2" data-id="element-682">
                  {showroom.title}
                </h3>
                <p className="text-gray-600" data-id="element-683">{showroom.description}</p>
              </div>
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-684">
          <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-685">
            Find Your Perfect Solution
          </a>
        </div>
      </div>
    </section>;
};
export default ShowroomTypes;